import React from 'react';
import { Card, CardHeader, CardBody, Row, Col } from 'reactstrap';
import { formatCurrency } from 'utils/fuctions/formatCurrency';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import {
  individual_column_style,
  individual_header_style
} from '../../../../../assets/styles/table_custom_style';
import { Container, Ul } from './styles';
import DOMPurify from 'dompurify';

export const PageToPrint = ({
  protocolNumber,
  comments,
  protocolData,
  customFields,
  defaultFields,
  selectedFields = {}
}) => {
  Object.byString = function (object, string) {
    string = string?.replace(/\[(\w+)\]/g, '.$1');
    string = string?.replace(/^\./, '');
    let a = string?.split('.');
    for (let i = 0, n = a?.length; i < n; ++i) {
      let k = a[i];
      if (!object) {
        return;
      }
      if (k in object) {
        object = object[k];
      } else {
        return;
      }
    }
    return object;
  };

  const defaultFieldsPaths = {
    client_id: 'client.nome',
    current_responsible: 'current_responsible',
    current_status: 'protocol_statuses[0].status.name',
    description: 'description',
    reason_id: 'reason.name',
    service_channel: 'service_channel',
    subreason_id: 'subreason.name',
    telephone: 'telephone',
    title: 'title',
    email: 'email',
    account_id: 'account.name'
  };

  const defaultFieldsNames = {
    client_id: 'Contato',
    current_responsible: 'Responsável',
    current_status: 'Status/Fase',
    description: 'Descrição',
    reason_id: 'Motivo',
    service_channel: 'Canal de atendimento',
    subreason_id: 'Submotivo',
    telephone: 'Telefone',
    title: 'Titulo',
    email: 'Email',
    account_id: 'Conta'
  };

  let customFieldsArray = [];
  let defaultFieldsArray = [];
  let description = undefined;
  let allFields = [];

  const setValueDyncamicField = (FieldName) => {
    if (!protocolData || !FieldName) return '';

    // Implementação feita para mitigar quebra de interface ao renderizar os protocolos
    for (let [key, value] of Object.entries(protocolData)) {
      if (key === FieldName) {
        if (value === null || value === undefined) return '';
        if (typeof value === 'object') {
          if (value.toString && typeof value.toString === 'function') {
            const stringValue = value.toString();
            return stringValue !== '[object Object]'
              ? stringValue
              : JSON.stringify(value);
          }
          return JSON.stringify(value);
        }
        return String(value);
      }
    }
    return '';
  };

  if (defaultFields) {
    let defaultFieldsKeys = Object.keys(defaultFields).filter((fieldKey) => {
      const isActive = defaultFields[fieldKey].isActive;
      const isSelected =
        Object.keys(selectedFields).length === 0 ||
        selectedFields[`default_${fieldKey}`];
      return isActive && isSelected;
    });

    defaultFieldsArray = defaultFieldsKeys.map((field) => {
      if (field === 'files') return;
      if (field === 'description') {
        description = (
          <p key={field}>
            <strong style={{ marginRight: '0.3rem' }}>
              {' '}
              {defaultFieldsNames[field]}:
            </strong>
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(
                  Object.byString(protocolData, defaultFieldsPaths[field]) ?? ''
                )
              }}
            />
          </p>
        );
        return;
      }

      return (
        <li key={field}>
          <strong style={{ marginRight: '0.3rem' }}>
            {defaultFieldsNames[field]}:
          </strong>
          {(() => {
            const value = Object.byString(
              protocolData,
              defaultFieldsPaths[field]
            );
            if (value === null || value === undefined) return '';
            if (typeof value === 'object') {
              if (value.toString && typeof value.toString === 'function') {
                const stringValue = value.toString();
                return stringValue !== '[object Object]'
                  ? stringValue
                  : JSON.stringify(value);
              }
              return JSON.stringify(value);
            }
            return String(value);
          })()}
        </li>
      );
    });
    allFields.push([...defaultFieldsArray.filter(Boolean)]);
  }

  if (customFields && Array.isArray(customFields)) {
    customFieldsArray = customFields
      .filter((field) => {
        if (!field || !field.name || !field.label) return false;
        const isSelected =
          Object.keys(selectedFields).length === 0 ||
          selectedFields[`custom_${field.name}`];
        return isSelected;
      })
      .map((field, index) => {
        const fieldValue = setValueDyncamicField(field.name);

        if (field.type === 'DATE') {
          let value = new Date(fieldValue);

          if (isNaN(value.getTime())) {
            return (
              <li key={index}>
                <strong style={{ marginRight: '0.3rem' }}>
                  {field.label}:
                </strong>
                {fieldValue || 'Data inválida'}
              </li>
            );
          }
          return (
            <li key={index}>
              <strong style={{ marginRight: '0.3rem' }}>{field.label}:</strong>
              {value.toLocaleDateString('pt-br')}
            </li>
          );
        }

        if (field.type === 'CURRENCY') {
          return (
            <li key={index}>
              <strong style={{ marginRight: '0.3rem' }}>{field.label}:</strong>
              {formatCurrency(fieldValue)}
            </li>
          );
        }

        return (
          <li key={index}>
            <strong style={{ marginRight: '0.3rem' }}>{field.label}:</strong>
            {fieldValue}
          </li>
        );
      });
    allFields.push([...customFieldsArray]);
  }

  return (
    <Container>
      <Card>
        <CardHeader>
          <h3 className="mb-0">Nº. do Protocolo {protocolNumber}</h3>
        </CardHeader>
        <CardBody>
          <label className="form-control-label">Dados do contato(s)</label>
          <Row style={{ flexDirection: 'column' }}>
            <Col>
              <Ul>
                {allFields && allFields.length
                  ? allFields.flat().filter(Boolean)
                  : null}
              </Ul>
            </Col>
            {description ? (
              <Col style={{ paddingLeft: '3.4375rem' }}>{description}</Col>
            ) : null}
          </Row>

          {comments &&
          comments.length &&
          (Object.keys(selectedFields).length === 0 ||
            selectedFields['comments']) ? (
            <>
              <label
                className="form-control-label"
                style={{ paddingTop: '25px' }}
              >
                Comentário(s)
              </label>
              <ToolkitProvider
                data={comments || []}
                keyField="id"
                columns={[
                  {
                    dataField: 'description',
                    text: 'Descrição',
                    sort: true,
                    style: {
                      ...individual_column_style,
                      whiteSpace: 'break-spaces'
                    },
                    headerStyle: individual_header_style,
                    formatter: (value) => {
                      const myHtml = `<div>${value}</div>`;
                      return (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(myHtml)
                          }}
                        />
                      );
                    }
                  },
                  {
                    dataField: 'creation_date',
                    text: 'Data de criação',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style,
                    formatter: (Row) => {
                      const date = new Date(Row);
                      return date.toLocaleDateString('pt-br');
                    }
                  }
                ]}
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <BootstrapTable
                      {...props.baseProps}
                      bootstrap4={true}
                      bordered={false}
                      classes="align-items-center"
                    />
                  </div>
                )}
              </ToolkitProvider>
            </>
          ) : null}
        </CardBody>
      </Card>
    </Container>
  );
};
